var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.93833 20.8033L2 22L3.19833 16.0625L7.93833 20.8033ZM4.37667 14.8833L9.11667 19.6242L22 6.74083L17.2592 2L4.37667 14.8833Z","fill":"currentColor"}));
}

Edit.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Edit;

Edit.default = Edit;
